import type { ReportReducerState } from 'Store/report/types';

const initialState: ReportReducerState = {
  // Dynamic tree flow
  currentNodeId: null,
  isDone: false,
  tree: {},
  // All flows
  isLoading: false,
  isReported: false,
};

export default initialState;
